import getBarChart from "./getBarChart";
import getDoughnutChart from "./getDoughnutChart";
import getLineChart from "./getLineChart";
import getMultiLineChart from "./getMultiLineChart";
import getDashboard from "./getDashboard";
const models = {
  getBarChart,
  getDoughnutChart,
  getLineChart,
  getMultiLineChart,
  getDashboard,
};
export default models;
